// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideNavOperator {
    justify-content: center;
}

.sideNavIcon {
    cursor: default;
}

.detailPanel {
    width: 200px;
    flex-shrink: 0;
}

.fieldHeader {
    height: 30px;
    width: 100%;
}

    .fieldHeader > * {
        align-self: center;
    }

    .fieldHeader > span {
        white-space: nowrap;
    }

    .fieldHeader > .fieldCheck {
        margin: 0px 5px;
    }`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/dialogs/rel.query.def.dialog.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;IAEI;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB","sourcesContent":[".sideNavOperator {\n    justify-content: center;\n}\n\n.sideNavIcon {\n    cursor: default;\n}\n\n.detailPanel {\n    width: 200px;\n    flex-shrink: 0;\n}\n\n.fieldHeader {\n    height: 30px;\n    width: 100%;\n}\n\n    .fieldHeader > * {\n        align-self: center;\n    }\n\n    .fieldHeader > span {\n        white-space: nowrap;\n    }\n\n    .fieldHeader > .fieldCheck {\n        margin: 0px 5px;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
